// footerImagePreload.js
import menuHomeActive from "../../../images/menu-home-active.svg";
import menuEventsActive from "../../../images/menu-events-active.svg";
import menuAddEventActive from "../../../images/menu-add-event-active.svg";
import menuExploreActive from "../../../images/menu-explore-active.svg";
import menuAccountActive from "../../../images/menu-account-active.svg";

import menuHome from "../../../images/menu-home.svg";
import menuEvents from "../../../images/menu-events.svg";
import menuAddEvent from "../../../images/add-green.svg";
import menuExplore from "../../../images/menu-explre.svg";
import menuAccount from "../../../images/menu-account.svg";

// event icons
import eventVaccine from '../../../images/event-vaccine.png';
import eventParasites from '../../../images/event-parasites.png';
import eventVet from '../../../images/event-vet.png';
import eventGroom from '../../../images/event-grooming.png';
import eventMed from '../../../images/event-medicine.png';
import eventOther from '../../../images/type-other.png';

// misc icons
import rightArrow from '../../../images/right-arrow.svg';

const iconsToPreload = [
  // footer
  menuHomeActive,
  menuEventsActive,
  menuAddEventActive,
  menuExploreActive,
  menuAccountActive,
  menuHome,
  menuEvents,
  menuAddEvent,
  menuExplore,
  menuAccount,

  // event types
  eventVaccine,
  eventParasites,
  eventVet,
  eventGroom,
  eventMed,
  eventOther,

  // misc
  rightArrow,
];

iconsToPreload.forEach((src) => {
  const img = new Image();
  img.src = src;
});
